// extracted by mini-css-extract-plugin
module.exports = {"search":"more-record_search_2uG6n","itemWrap":"more-record_itemWrap_ET6rq","item":"more-record_item_3CmKx"};